import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router';
import { t } from '../../../../modules/infra/i18n';
import SimpleHeader from '../../headers/simpleHeader';
import BankAccountForm from './bankAccountForm';
import BankAccountEntity from './bankAccountEntity';
import BankAccountVerificationError from './bankAccountVerificationError';
import iosBridge from '../../../iosBridge/iosBridgeService';

class BankAccountEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      errors: null,
      bankAccount: null,
      busy: false,
      initialized: false,
    };
  }

  componentDidMount() {
    const { fetchBankAccount } = this.props;

    fetchBankAccount().then((account) => {
      if (!account) {
        return;
      }

      const bankAccount = new BankAccountEntity(account);

      const initialValues = {
        routing_number: bankAccount.getExternalAccount().routing_number,
        account_number: `********${bankAccount.getExternalAccount().last4}`,
        first_name: bankAccount.getLegalEntity().first_name,
        last_name: bankAccount.getLegalEntity().last_name,
        date_of_birth: moment()
          .year(bankAccount.getLegalEntity().dob.year)
          .month(bankAccount.getLegalEntity().dob.month - 1)
          .date(bankAccount.getLegalEntity().dob.day)
          .startOf('day')
          .toDate(),
        type: bankAccount.getLegalEntity().type,
        phone: bankAccount.getLegalEntity().personal_phone_number,
        email: bankAccount.getLegalEntity().personal_email,
        business_name: bankAccount.getLegalEntity().business_name || '',
        ein_provided: bankAccount.getLegalEntity().business_tax_id_provided,
        address: bankAccount.getAddress(),
      };

      this.setState({ initialValues, bankAccount, initialized: true });
    }).catch(() => {
      this.setState({ initialized: false });
    });
  }

  saveBankAccount = (model, documents) => {
    this.setState({ busy: true, errors: null });
    const { modifyBankAccount, uploadBankAccountDocuments, bankAccount, router, redirectTo } = this.props;

    if (model.account_number && model.account_number[0] === '*') {
      delete model.account_number;
      delete model.routing_number;
    }

    if (model.personal_id_number_provided && model.personal_id_number && model.personal_id_number.length < 9) {
      delete model.personal_id_number;
    }

    return modifyBankAccount(bankAccount.id, model)
      .then(() => {
        if (!isEmpty(documents)) {
          return uploadBankAccountDocuments(documents);
        }

        return Promise.resolve();
      })
      .then(() => {
        iosBridge.callHandler('bankAccount://saved');
        router.push(redirectTo);
        this.setState({ busy: false });
      }).catch((err) => {
        this.setState({ busy: false, errors: err.message });
      });
  }

  handleCancelClick() {
    iosBridge.callHandler('bankAccount://cancel');
  }

  render() {
    const changeExternalAccount = Boolean(this.props.params.editExternal);
    return (
      <div>
        <SimpleHeader heading={t('settings:bank_account_edit.title')} />
        <div className="c-wrapper">
          <div className="layout">
            <div className="layout__item u-5/10-extralarge-and-up">
              <div className="c-inner-wrapper u-margin-0">
                <div className="c-label c-label--light u-pb--" display-if={!changeExternalAccount}>{t('settings:bank_account_edit.label')}</div>
                <div className="c-paragraph u-mb-" display-if={!changeExternalAccount}>
                  {t('settings:bank_account_edit.description')}
                </div>
                <div
                  className="c-login-error-message u-text-left"
                  display-if={this.state.bankAccount && this.state.bankAccount.getVerificationErrors().length}
                >
                  {this.state.bankAccount.getVerificationErrors().map((err) => (
                    <BankAccountVerificationError err={err} />
                  ))}
                </div>
                <BankAccountForm
                  display-if={this.state.initialized}
                  currency={this.props.currentShop.currency}
                  formErrors={this.state.errors}
                  isEditPage
                  changeExternalAccount={changeExternalAccount}
                  account={this.state.bankAccount}
                  saveBankAccount={this.saveBankAccount}
                  initialValues={this.state.initialValues}
                  cancelUrl={this.props.redirectTo}
                  busy={this.state.busy}
                  onCancelClick={this.handleCancelClick}
                />
              </div>
            </div>
            <div className="layout__item u-4/10-extralarge-and-up">
              <div className="c-label c-label--light u-pb--">{t('settings:bank_account_edit.when_deposited_title')}</div>
              <div className="c-paragraph u-pb--">
                {t('settings:bank_account_edit.when_deposited_description')}
              </div>
              <div className="c-label c-label--light u-mt u-pb--">{t('settings:bank_account_edit.closed_account_title')}</div>
              <div className="c-paragraph u-pb--">
                {t('settings:bank_account_edit.closed_account_description')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BankAccountEdit.propTypes = {
  modifyBankAccount: PropTypes.func.isRequired,
  bankAccount: PropTypes.object,
  router: PropTypes.object,
  currentShop: PropTypes.object,
  fetchBankAccount: PropTypes.func.isRequired,
  uploadBankAccountDocuments: PropTypes.func.isRequired,
  redirectTo: PropTypes.string,
  params: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  bankAccount: state.settings.bankAccount,
});

export default connect(
  mapStateToProps,
)(withRouter(BankAccountEdit));
